import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Minus, Plus, Check, ShoppingCart, Gift, Lock } from "lucide-react";
import { useApp } from "../context/AppContext";
import { TVA } from "../data/mock";

const fmt = (n) => new Intl.NumberFormat("fr-DZ").format(Math.round(n));

const ProductCard = ({ product }) => {
  const { t, tf, addToCart, isPro } = useApp();
  const [qty, setQty] = useState(product.moq);
  const [done, setDone] = useState(false);

  const hasPrice = isPro && product.priceHT != null;
  const ttc = product.priceHT != null ? product.priceHT * (1 + TVA) : 0;

  const handleAdd = () => {
    addToCart(product.id, qty);
    setDone(true);
    setTimeout(() => setDone(false), 1400);
  };

  return (
    <div className="prod-card bg-white rounded-2xl overflow-hidden border border-gray-100 flex flex-col">
      <div className="relative h-48 overflow-hidden bg-cream">
        <img src={product.image} alt={tf(product.name)} className="w-full h-full object-cover" loading="lazy" />
        <span className="absolute top-3 ltr:left-3 rtl:right-3 bg-navy text-white text-[11px] font-display font-semibold px-2.5 py-1 rounded-full">
          {tf(product.vendorType)}
        </span>
        <span className="absolute top-3 ltr:right-3 rtl:left-3 bg-white/90 text-navy text-[11px] font-display font-bold px-2.5 py-1 rounded-full">
          {t("moq")} {product.moq}
        </span>
        {product.promo && (
          <span className="absolute bottom-3 ltr:left-3 rtl:right-3 bg-orange text-white text-[11px] font-display font-bold px-2.5 py-1 rounded-full shadow-lg flex items-center gap-1" data-testid="promo-badge">
            <Gift size={12} /> {product.promo}
          </span>
        )}
      </div>

      <div className="p-5 flex flex-col flex-1">
        {product.brand && <p className="text-[11px] font-display font-bold text-orange uppercase tracking-wide" data-testid={`product-brand-${product.id}`}>{product.brand}</p>}
        <h3 className="font-display font-bold text-navy leading-snug text-[15px] min-h-[42px]">{tf(product.name)}</h3>
        {product.dlc && <p className="text-[11px] text-gray-500 mt-1">DLC : {product.dlc}</p>}
        <p className="text-sm text-gray-500 mt-2 leading-relaxed line-clamp-2 flex-1">{tf(product.desc)}</p>

        {hasPrice ? (
          <>
            <div className="mt-4 flex items-end justify-between">
              <div>
                <div className="font-display">
                  <span className="text-2xl font-extrabold text-navy">{fmt(product.priceHT)}</span>
                  <span className="text-navy font-bold"> {t("currency")}</span>
                </div>
                <div className="text-[11px] text-gray-400">{t("ht_unit")}{tf(product.unit)}</div>
                <div className="text-xs text-gray-500 mt-0.5">{fmt(ttc)} {t("currency")} {t("ttc")}</div>
              </div>
            </div>

            <div className="mt-4 flex items-center gap-2">
              <div className="flex items-center border border-gray-200 rounded-full">
                <button onClick={() => setQty((q) => Math.max(product.moq, q - 1))} className="p-2 text-navy hover:text-orange" aria-label="-"><Minus size={15} /></button>
                <span className="w-8 text-center font-display font-bold text-navy text-sm">{qty}</span>
                <button onClick={() => setQty((q) => q + 1)} className="p-2 text-navy hover:text-orange" aria-label="+"><Plus size={15} /></button>
              </div>
              <button onClick={handleAdd} data-testid={`add-to-cart-${product.id}`}
                className={`flex-1 font-display font-semibold text-sm rounded-full py-2.5 flex items-center justify-center gap-1.5 transition-colors ${done ? "bg-green-600 text-white" : "btn-orange"}`}>
                {done ? <><Check size={16} /> {t("added")}</> : <><ShoppingCart size={16} /> {t("add")}</>}
              </button>
            </div>
          </>
        ) : (
          <div className="mt-4">
            <div className="rounded-xl bg-navy/5 px-3 py-2.5 flex items-center gap-2 text-navy" data-testid="price-locked">
              <Lock size={15} className="text-orange shrink-0" />
              <span className="font-display font-semibold text-sm">{t("price_locked")}</span>
            </div>
            <Link to="/connexion" data-testid={`login-to-see-price-${product.id}`}
              className="mt-3 w-full btn-navy font-display font-semibold text-sm rounded-full py-2.5 flex items-center justify-center gap-1.5">
              {t("login_to_price")}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
